"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickActionsItem = QuickActionsItem;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Button = _interopRequireDefault(require("../../Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Menu = require("../../Menu");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/**
 * A quick actions item
 */
function QuickActionsItem(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      isMenuItem = _ref.isMenuItem,
      ariaLabel = _ref['aria-label'],
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "icon", "label", "onClick", "isMenuItem", "aria-label"]);
  return isMenuItem ? _react["default"].createElement(_Menu.MenuItem, (0, _extends2["default"])({}, otherProps, {
    className: "spectrum-".concat(QuickActionsItem.displayName),
    icon: icon,
    onClick: onClick,
    "aria-label": ariaLabel
  }), label) : _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, otherProps, {
    className: (0, _classnames["default"])(className, "spectrum-".concat(QuickActionsItem.displayName)),
    variant: "action",
    quiet: true,
    icon: icon,
    label: icon ? undefined : label,
    "aria-label": icon ? ariaLabel || label : ariaLabel,
    onClick: onClick,
    role: "menuitem"
  }));
}

QuickActionsItem.displayName = 'QuickActionsItem';
QuickActionsItem.propTypes = {
  /**
   * Custom className to apply to this component.
   */
  className: _propTypes["default"].string,

  /**
   * An icon to render in the quick actions item.
   */
  icon: _propTypes["default"].element,

  /**
   * The label to display in the quick actions item.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * Callback for when the quick action item is clicked.
   */
  onClick: _propTypes["default"].func
};